import * as React from 'react';
import ColorButton from 'antd-button-color';
import { Button as AntButton } from 'antd';

export type ButtonProps = {
  children?: React.ReactNode | string;
  type: 'default' | 'primary' | 'success' | 'info' | 'danger' | 'warning' | 'dark' | 'lightdark' | 'ghost' | 'dashed' | 'text' | 'link';
  size: 'large' | 'middle' | 'small';
  disabled: boolean;
  icon?: React.ReactNode;
  block: boolean;
  ghost: boolean;
  shape?: 'circle' | 'round';
  onClick?: () => void;
};

const Button = (props: ButtonProps & (React.ComponentProps<typeof ColorButton> | React.ComponentProps<typeof AntButton>)) => {
  const { className, type } = props;
  const classNames = [className, type, 'button'];
  return <ColorButton {...props} className={classNames.join(' ')} />;
};

Button.defaultProps = {
  type: 'dark',
  size: 'middle',
  disabled: false,
  block: false,
  ghost: false,
};

export default Button;
